<template>
  <v-row>
    <v-col cols="12">
      <b-input
        v-model="form.topic"
        :error-messages="getErrorMessages(v$.topic)"
        label="Назва"
        placeholder="Коротко сформулюйте недолік"
        @blur="v$.topic.$touch()"></b-input>
      <b-textarea
        v-model="form.description"
        :error-messages="getErrorMessages(v$.description)"
        label="Опис"
        placeholder="Опишіть суть недоліку та очікуваний результат виконання"
        rows="4"
        @blur="v$.description.$touch()"></b-textarea>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { PropType, reactive } from 'vue'
import { BInput, BTextarea } from 'best-modules/components'
import { getErrorMessages } from 'best-modules/utils'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { Dialog } from '@/dialog'
import { urlAllUsers } from '@/utils/urls'
import type { IncidentIssueCredentials } from '@/utils/types/incident'
import { incidentIssueCreate, incidentIssueUpdate } from '@/requests/incident'
import { setSnackbar } from 'best-modules/plugins'

export default {
  name: 'IncidentIssue',
  components: {
    BInput,
    BTextarea,
  },
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: {
    getErrorMessages,
    urlAllUsers,
  },
  setup(props) {
    const form = reactive<IncidentIssueCredentials>({
      incidentId: props.dialog.dialogData?.incidentId || null,
      topic: props.dialog.dialogData?.issue?.topic || null,
      description: props.dialog.dialogData?.issue?.description || null,
    })

    const rules = {
      topic: { required },
      description: { required },
    }

    const v$ = useVuelidate(rules, form)

    const submit = () => {
      if (props.dialog.action === 'create') {
        return incidentIssueCreate({ ...form }).then(issue => {
          setSnackbar({
            color: 'success',
            text: 'Недолік створено',
          })

          return issue
        })
      } else {
        return incidentIssueUpdate(
          { topic: form.topic, description: form.description },
          props.dialog.dialogData.issue?.id
        ).then(issue => {
          setSnackbar({
            color: 'success',
            text: 'Недолік оновлено',
          })

          return issue
        })
      }
    }

    return { form, submit, v$ }
  },
}
</script>
